import Vue from 'vue';
import InputLine from './inputline.vue';

Vue.component(InputLine.name, InputLine);
